export default __webpack_public_path__ + "static/media/Issue.15271b1b.svg";